import { render, staticRenderFns } from "./PushBtn.vue?vue&type=template&id=e6d81c18&scoped=true&lang=pug&"
import script from "./PushBtn.vue?vue&type=script&lang=js&"
export * from "./PushBtn.vue?vue&type=script&lang=js&"
import style0 from "./PushBtn.vue?vue&type=style&index=0&id=e6d81c18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d81c18",
  null
  
)

export default component.exports